import { Grid } from '@material-ui/core';
import React from 'react';
import * as Yup from 'yup';
import FormField from '../../FindYourStrategy/FormikForms/FormField';
import { Label, TextField } from '../../formikFormInputs';
import PasswordRequirements from './PasswordRequirements';
import {
  initFalse,
  PWD_MIN_EIGHT_CHAR_REGEX,
  PWD_ONE_CAPITAL_LETTER_REGEX,
  PWD_ONE_LETTER_REGEX,
  PWD_ONE_NUMBER_REGEX,
  PWD_ONE_SPECIAL_CHAR
} from '../../../utils/constants';
import { REQUIRED, required } from '../../../utils/validation';


export const PasswordInputs = ({ errors, values, touched, handleChange, handleBlur }: any) => {
    const [oneLetter, setOneLetter] = React.useState(false);
    const [oneNumber, setOneNumber] = React.useState(false);
    const [oneCapitalLetter, setOneCapitalLetter] = React.useState(false);
    const [eightCharacter, setEightCharacter] = React.useState(false);
    const [oneSpecialChar, setOneSpecialChar] = React.useState(false);

    const onPassWordChange = (e: any): void => {
        const val = e.target.value;
        PWD_ONE_LETTER_REGEX.test(val) ? setOneLetter(true) : setOneLetter(false)
        PWD_ONE_CAPITAL_LETTER_REGEX.test(val) ? setOneCapitalLetter(true) : setOneCapitalLetter(false);
        PWD_ONE_NUMBER_REGEX.test(val) ? setOneNumber(true) : setOneNumber(false);
        PWD_MIN_EIGHT_CHAR_REGEX.test(val) ? setEightCharacter(true) : setEightCharacter(false);
        PWD_ONE_SPECIAL_CHAR.test(val) ? setOneSpecialChar(true) : setOneSpecialChar(false);
    }

    const passwordField = {
        component: TextField,
        label: <Label label={"Create a Strong Password"} required={!initFalse} />,
        name: "password",
        rowSize: 12,
        type: "password",
        validate: required
    };
    const confirmPasswordField = {
        component: TextField,
        label: <Label label={"Confirm Password"} required={!initFalse} />,
        name: "confirmPassword",
        rowSize: 12,
        type: "password",
        validate: required
    };

    const onChange = (event: any) => {
        handleChange(event);
        onPassWordChange(event);
    }

    return (
        <>
            <FormField
                values={values}
                errors={errors}
                touched={touched}
                handleChange={onChange}
                handleBlur={handleBlur}
                {...passwordField}
            />
            <FormField
                values={values}
                errors={errors}
                touched={touched}
                handleChange={onChange}
                handleBlur={handleBlur}
                {...confirmPasswordField}
            />
            <Grid item xs={12}>
                <PasswordRequirements oneLetter={oneLetter} oneNumber={oneNumber} oneCapitalLetter={oneCapitalLetter} eightCharacter={eightCharacter} oneSpecialChar={oneSpecialChar} />
            </Grid>
        </>
    )
}

const regexMessage = "Password don't meet password requirements, see below"

export const validationPasswordInputs = {
    password: Yup.string().required(REQUIRED)
        .matches(PWD_ONE_LETTER_REGEX, regexMessage)
        .matches(PWD_ONE_CAPITAL_LETTER_REGEX, regexMessage)
        .matches(PWD_ONE_NUMBER_REGEX, regexMessage)
        .matches(PWD_MIN_EIGHT_CHAR_REGEX, regexMessage)
        .matches(PWD_ONE_SPECIAL_CHAR, regexMessage),
    confirmPassword: Yup.string().required('Confirm Password is required field').oneOf([Yup.ref('password')], "Passwords don't match"),
}

export const initialValuesPasswordInputs = {
    password: '',
    confirmPassword: '',
}
